import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import QueryString from 'qs'
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { ReqMethods, ghl } from 'enums'
import env from 'config'
import { useAppServices } from 'hook/services'
import { useBrandInfo } from 'context/brand'

function InstallEvent() {
  const navigate = useNavigate()
  const { search } = useLocation()
  const code = new URLSearchParams(search).get('code')

  const AppServices = useAppServices()
  const [Error, setError] = useState('')
  const [brand, update] = useBrandInfo()

  const associate = async (creds) => {
    const payload = {
      ghl: {
        location_id: creds.locationId,
        company_id: creds.companyId,
        access_token: creds.access_token,
        refresh_token: creds.refresh_token,
      },
    }

    const { response } = await AppServices.install_event_app_setup.update({ payload })

    if (!response) {
      setError('Something went wrong while integration, please try later')
      return
    }

    update(payload)
    navigate(-2)
  }

  const getCreds = async () => {
    const payload = {
      method: ReqMethods.POST,
      path: ghl.APIs.oauth,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      payload: QueryString.stringify({
        client_id: env.GHL.INSTALL_APP_CLIENT_ID,
        client_secret: env.GHL.INSTALL_APP_CLIENT_SECRET,
        grant_type: 'authorization_code',
        code,
        refresh_token: '',
      }),
    }

    const { response } = await AppServices.services.ghl.call_service({ payload })

    if (!response) {
      setError('Something went wrong while integration, please try later')
      return
    }

    associate(response.data)
  }

  useEffect(() => {
    if (!code) {
      setError('Authorization code not found')
    } else {
      getCreds()
    }
  }, [])

  return (
    <MDBox>
      {!Error && <MDBox>Integrating, please wait...</MDBox>}
      {Error && (
        <MDBox>
          <MDBox color="error">{Error}</MDBox>
          <MDButton onClick={() => navigate(-2)}>Go Back</MDButton>
        </MDBox>
      )}
    </MDBox>
  )
}

export default InstallEvent
